<template>
  <div class="app">
    <!-- 装饰元素 -->
    <div class="decoration decoration-1"></div>
    <div class="decoration decoration-2"></div>
    <div class="decoration decoration-3"></div>
    
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    document.title = '员工自助报销系统'
  }
}
</script>

<style>
.app {
  min-height: 100vh;
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
}

/* 装饰元素 */
.decoration {
  position: absolute;
  border-radius: 50%;
  z-index: 0;
}

.decoration-1 {
  width: 400px;
  height: 400px;
  top: -200px;
  left: -100px;
  background: rgba(144, 202, 249, 0.3);
}

.decoration-2 {
  width: 300px;
  height: 300px;
  bottom: -150px;
  right: -100px;
  background: rgba(179, 157, 219, 0.3);
}

.decoration-3 {
  width: 200px;
  height: 200px;
  bottom: 10%;
  left: 10%;
  background: rgba(129, 199, 132, 0.3);
}
</style>
